module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/screen.969ac655.gif";